// import { taxCountryCode } from "src/config";
// import {
//   cityAirportDictionaries,
//   itineraryProps,
//   locationProps,
//   segmentProps,
// } from "src/interfaces";

// export const getCanadaToCanada = (
//   segments: Segment[],
//   fromIataCode: string,
//   toIataCode: string
// ) => {
//   const startIndex = segments.findIndex(
//     (seg) => seg.departure.iataCode === fromIataCode
//   );

//   const endIndexFromEnd = [...segments]
//     .reverse()
//     .findIndex((seg) => seg.arrival.iataCode === toIataCode);

//   const endIndex =
//     endIndexFromEnd !== -1 ? segments.length - 1 - endIndexFromEnd : -1;

//   if (startIndex === -1 || endIndex === -1 || startIndex > endIndex) {
//     return null; // No valid route
//   }

//   const startSegment = segments[startIndex];
//   const endSegment = segments[endIndex];

//   return {
//     departure: {
//       iataCode: startSegment.departure.iataCode,
//       at: startSegment.departure.at,
//     },
//     arrival: {
//       iataCode: endSegment.arrival.iataCode,
//       at: endSegment.arrival.at,
//       terminal: endSegment.arrival.terminal,
//     },
//     startIndex,
//     endIndex,
//   };
// };

// export const getAirportName = (
//   cityAirportDictionaries: cityAirportDictionaries,
//   iataCode: string
// ) => {
//   const cityAirportData = cityAirportDictionaries["A" + iataCode]?.data;

//   let fullName: string = `${
//     cityAirportDictionaries["A" + iataCode]?.data?.name || iataCode
//   } Airport (${iataCode})`;
//   let countryCode =
//     cityAirportDictionaries["A" + iataCode]?.data?.address?.countryCode;
//   if (!fullName?.includes(cityAirportData?.address?.cityName)) {
//     fullName = `${cityAirportData?.address?.cityName || ""} ${fullName}`;
//   }
//   return {
//     fullName: fullName,
//     countryCode: countryCode,
//   };
// };

// export const getCarriers = (itineraries: itineraryProps[]) => {
//   let carrierCodes = [];
//   itineraries?.map((item) => {
//     const carrierCode = item?.segments?.map((subItem) => subItem?.carrierCode);
//     carrierCodes = [...new Set([...carrierCodes, ...carrierCode])];
//   });
//   return carrierCodes;
// };

import { taxCountryCode } from "src/config";
import {
  cityAirportDictionaries,
  itineraryProps,
  locationProps,
  segmentProps,
} from "src/interfaces";

export const getCanadaToCanada = (
  segments: segmentProps[],
  locations: locationProps = {}
) => {
  let status = false;
  const startSegment = segments[0];
  const lastSegment = segments[segments?.length - 1];

  status =
    locations[startSegment?.departure?.iataCode]?.countryCode ===
      taxCountryCode &&
    locations[lastSegment?.arrival?.iataCode]?.countryCode === taxCountryCode;
  return status;
};

export const getAirportName = (
  cityAirportDictionaries: cityAirportDictionaries,
  iataCode: string
) => {
  const cityAirportData = cityAirportDictionaries["A" + iataCode]?.data;

  let fullName: string = `${
    cityAirportDictionaries["A" + iataCode]?.data?.name || iataCode
  } Airport (${iataCode})`;
  let countryCode =
    cityAirportDictionaries["A" + iataCode]?.data?.address?.countryCode;
  if (!fullName?.includes(cityAirportData?.address?.cityName)) {
    fullName = `${cityAirportData?.address?.cityName || ""} ${fullName}`;
  }
  return {
    fullName: fullName,
    countryCode: countryCode,
  };
};

export const getCarriers = (itineraries: itineraryProps[]) => {
  let carrierCodes = [];
  itineraries?.map((item) => {
    const carrierCode = item?.segments?.map((subItem) => subItem?.carrierCode);
    carrierCodes = [...new Set([...carrierCodes, ...carrierCode])];
  });
  return carrierCodes;
};
